import React from 'react'
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';

import servicioFormatos from '../servicios/ServicioFormatos';
import servicioReceptor from '../servicios/ServicioReceptor';
import servicioUsoCfdi from '../servicios/ServicioUsoCfdi';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioDescargaArchivos from '../servicios/ServicioArchivos';
import servicioMaterial from '../servicios/ServicioMaterial';
import servicioAtributo from '../servicios/ServicioAtributo';
import servicioIngresosDiversos from '../servicios/ServicioIngresosDiversos';
import servicioIdioma from '../servicios/ServicioIdiomaFecha';
import servicioHttp from '../servicios/ServicioHttp';
import servicioObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import { TabView, TabPanel } from 'primereact/tabview';
import { InformacionGlobal } from './InformacionGlobal';




import { Slider } from 'primereact/slider';

import Receptor from './Receptor';
import ServicioObjetos from '../servicios/ServicioAsignacionValoresObjetos';

export class FacturacionOtrosIngresos extends React.Component {

  constructor() {

    super();
    this.state = {
      
      objetoTasaoCuota:{},

      objetoTasaOcuotaTraslado:{},
      listaimpuestoRetencion:[],
      listaTipoFactorRetenido:[],
      listaTasaoCuotaRetenido:[],
      listaImpuestosRetenciones:[],


      objetoImpuesto: null,
      listaimpuestoTrasladado: [],
      listaTipoFactor: [],
      trasladoDR: {},
      retencionDR:{},
      errores: {},
      objetoTasaoCuota: {},
      listaTasaoCuota: [],
      listaImpuestosTrasladados: [],
      impuestosP: {},
      totales: {},


      modalImpuestoTraslados: false,
      modalImpuestoRetenidos:false,
      informacionGlobal: {},
      mostrarMoldaReceptor: false,
      receptor: {},
      erroresRequeridos: {},
      valorencontrado: null,
      listaReceptor: [],
      listaTabla: null,
      usosCfdi: [],
      listaRegimenFiscalReceptor: [],
      erroresFrmDatos: [],
      urlBusquedaReceptor: 'receptor/buscar_receptor_por_rfc.json',
      urlBusquedaUsosCfdi: 'usocfdi40/uso_cfdi_por_rfc.json',
      urlDescargaArchivosFacturacion: 'documentos/descargarzip.json',
      comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 }, conceptos: { concepto: [] } },
      conceptos: [],
      concepto: { atributos: {} },
      listaMateriales: [],
      paginacion: {},
      listaAtributos: [],
      indexConcepto: null,
      botonEditarConcepto: false,
      tipoDeComprobante: {},
      formaPago: {},
      listaReceptorConfirmacion: [],
      mostrarModalResultado: false,
      listaResultados: [],
      mostrarCfdiRelacionado: false,
      apartadoCfdiRelacionado: false,
      tiporelacion: {},
      folioFiscal: {},
      metodoPago: {},
      banderaPagos: false,
      pagos: {},
      modalPagos: false,
      pago: {},
      doctoRelacionado: {},
      indexPagos: null,
      botonEditarPago: false,
      erroresFrmDatosFiscales: {},
      urlRegimenFiscal: 'regimen/usocfdi_rfc.json',
      urlValidarReceptor40: 'receptor/validar_receptor40.json'
    };
  }


  actualizaReceptor = (receptor) => {
    this.setState({ receptor });
  }

  actualizaErroresFrmDatosFiscales = (erroresFrmDatosFiscales) => {
    this.setState({ erroresFrmDatosFiscales });
  }

  asignarValoresObjeto = (event) => {
    
    let { objetoImpuesto, retencionDR } = this.state;
    if(event.target!==undefined){

      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);

    if (event.target.name === "trasladoDR.impuestoDR") {
      // this.buscarTasaOCuota();

    }
    if (event.target.name === "trasladoDR.tipoFactorDR") {
      this.buscarTasaOCuota();
    }

    if (event.target.name === "retencionDR.tipoFactorDR") {
      this.buscarTasaOCuotaRetenido();
    }

    if (event.target.name === "doctoRelacionado.objetoImpDR") {
      

      objetoImpuesto = event.target.value.code;
      this.setState({ objetoImpuesto });
    }

    if(event.target ==="retencionDR.tasaOCuotaDR"){
      
    }

    }else{
      retencionDR.tasaOCuotaDR= event.value;
      this.setState({ retencionDR});
    }
    
    
  }

  valorSlider=(e)=>{
     
  }

  asignarTipoComprobante = (e) => {
    this.setState({ tipoDeComprobante: e.target.value, apartadoCfdiRelacionado: true })
    if (e.target.value.code === 'P') {
      //receptor.usoCfdi = { id: 22, clave: "P01", descripcion: "Por definir", formaPago: {}, metodoPago: {} };
      //this.setState({ banderaPagos: true, receptor });
      this.setState({ banderaPagos: true });
    } else {
      //receptor.usoCfdi = { id: 3, clave: "G03", descripcion: "Gastos en general" };
      //this.setState({ banderaPagos: false, receptor });
      this.setState({ banderaPagos: false });
    }
  }


  preguardarReceptor = () => {
    this.setState({ receptor: {}, mostrarMoldaReceptor: true });
  }

  buscarReceptorLike = (valor) => {
    setTimeout(() => {

      if (valor.query.length === 0) {

      }
      else {
        servicioReceptor.buscarReceptorLike({ rfc: valor.query.toUpperCase() }).then(response => {
          if (response.data.error) {
            this.growl.show({ life: 6000, severity: 'error', summary: 'Mensaje', detail: response.data.mensaje });
            this.setState({ valorencontrado: response.data.lista });
          } else {
            this.growl.show({ life: 1000, severity: 'success', summary: '\u00c9xito Mensaje', detail: response.data.mensaje });
            this.setState({ valorencontrado: response.data.lista });
          }
        }).catch((error) => {
          this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
        });
      }

    }, 250);
  }

  cargarValores = (event) => {
    if (event.value.rfc !== undefined) {
      const { receptor } = this.state;
      receptor['rfc'] = event.value.rfc;
      this.setState({ receptor });
      this.setState({ listaTabla: [event.value] });
      this.buscarReceptor();
    }
    this.setState({ listaReceptor: event.value })
  }

  buscarReceptor = () => {
    let { receptor, erroresFrmDatosFiscales, urlBusquedaReceptor, urlBusquedaUsosCfdi } = this.state;
    erroresFrmDatosFiscales = {};
    delete receptor.usoCfdi;
    if (receptor.rfc !== undefined && receptor.rfc.length >= 12) {
      servicioReceptor.buscarRfcReceptorPorRfc(urlBusquedaReceptor, receptor).then(response => {
        if (response) {
          receptor = response.data.objeto;
          
          if (response.data.error) {
            erroresFrmDatosFiscales.rfc = response.data.mensaje;
            receptor = {};
            this.growl.show({ severity: 'error', summary: 'Error', detail: response.data.mensaje });
          } else {
            servicioUsoCfdi.buscarUsoCfdiPorLongitudRfcReceptor(urlBusquedaUsosCfdi, receptor.rfc).then(response => {
              this.setState({ usosCfdi: response.data.lista });

              this.obtener_regimen_fiscal();
            }).catch(error => {

            });
          }
          receptor.usoCfdi = { id: 3, clave: "G03", descripcion: "Gastos en general" };
          this.setState({ receptor: receptor });
          this.setState({ erroresFrmDatosFiscales: erroresFrmDatosFiscales });
        }
      }).catch(error => {

      });
    } else {
      this.growl.show({ severity: 'error', summary: 'Error', detail: "La longitud del rfc debe de ser mínimo de 12 caracteres" });
    }
  }

  columnaEditarReceptor = (rowData, column) => {
    return <div>
      <Button tooltip="Editar receptor" type="button" icon="pi-md-edit" className="p-button-warning" onClick={this.preEditarReceptor.bind(this, rowData)}></Button>
    </div>;
  }

  preEditarReceptor = (objeto) => {
    this.setState({ receptor: objeto, mostrarMoldaReceptor: true });
  }

  guardarReceptor = () => {
    const { receptor } = this.state;
    const resultadoValidacion = this.validarRequeridos(receptor);
    this.setState({ erroresRequeridos: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      servicioReceptor.guardarReceptor(receptor).then(response => {
        if (response.data.error) {
          this.growl.show({ life: 8000, severity: 'error', summary: 'Mensaje', detail: response.data.mensaje });
        } else {
          this.growl.show({ life: 6000, severity: 'success', summary: '\u00c9xito Mensaje', detail: response.data.mensaje });
          this.setState({ receptor: response.data.objeto, mostrarMoldaReceptor: false, erroresRequeridos: {}, listaReceptor: [] });
        }
      })
    }

  }

  validarRequeridos = (receptor, informacionGlobal) => {
    const erroresRequeridos = {};
    const mensajesError = [];
    let patron = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]{3}$/;

    if (!receptor.rfc) {
      erroresRequeridos.rfc = "El rfc es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Rfc de Receptor', detail: erroresRequeridos.rfc });

    }

    if (!patron.test(receptor.rfc)) {
      mensajesError.push({ life: 7000, severity: 'error', summary: '', detail: 'El RFC no cumple con un patrón válido.  Ejemplo: Persona Física o Persona Moral' });
      erroresRequeridos.rfc = "El rfc es inválido";
    }

    if (!receptor.nombre) {
      erroresRequeridos.nombre = "El nombre es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Nombre de Receptor', detail: erroresRequeridos.nombre });

    }

    if (!servicioAsignacionValoresObjetos.esObjetoVacio(receptor.rfc) && receptor.rfc === "XAXX010101000") {
      if (servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal.periodicidad)) {
        erroresRequeridos.periodicidad = "Periodicidad es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Periodicidad', detail: erroresRequeridos.periodicidad });

      }

      if (servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal.meses)) {
        erroresRequeridos.meses = "Meses es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Meses', detail: erroresRequeridos.meses });
      }

      if (servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal.anio)) {
        erroresRequeridos.anio = "Año es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Año', detail: erroresRequeridos.anio });
      }

    }

    // if (!receptor.correo) {
    //   erroresRequeridos.correo = "El correo es requerido";
    //   mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Correo de Receptor', detail: erroresRequeridos.correo });
    // }

    if (Object.keys(erroresRequeridos).length) {
      this.growl.show(mensajesError);
    }

    return erroresRequeridos;
  }

  nuevoConcepto = () => {
    this.buscar_materiales();
    this.setState({ concepto: { cantidad: 0.00, total: 0.00, costo: 0.00, atributos: {} }, modalConceptos: true, listaAtributos: [], botonEditarConcepto: false });
  }

  buscar_materiales = () => {
    let { paginacion } = this.state;
    paginacion["registrosPorPagina"] = 500;
    servicioMaterial.paginacion(paginacion).then(response => {
      if (response.data.objeto != null)
        this.setState({ listaMateriales: response.data.objeto.datos });
    });
  }

  buscar_atributos = (event) => {
    let { listaAtributos, concepto } = this.state;
    concepto.ingresodiverso = event.target.value
    this.lista_atributos(concepto, listaAtributos, false);

  }

  lista_atributos = (obj, arrayr, modalTrue) => {
    servicioAtributo.buscarAtributos(obj.ingresodiverso).then((response) => {
      if (response.data.error === false) {
        arrayr = response.data.lista
        if (modalTrue) {
          this.setState({ concepto: obj, modalConceptos: true, listaAtributos: arrayr });

        }
        else {
          obj.atributos = {};
          obj.iva = 0.0;
          obj.isr = 0.0;
          obj.totalSumaIva = 0.0;
          obj.totalRetenido = 0.0;
          obj.totalIva = 0.0;
          obj.total = 0.0;
          obj.costo = 0.0;
          this.setState({ concepto: obj, listaAtributos: arrayr });
        }
      }
    }).catch((error) => {

    });
  }

  asignarValorLista = (event) => {
    let { concepto } = this.state;
    let nombrePropiedad = event.target.name;
    let valorPropiedad = event.target.value;
    if (valorPropiedad && typeof valorPropiedad !== 'object')
      valorPropiedad = valorPropiedad.toUpperCase();
    concepto.atributos[nombrePropiedad] = valorPropiedad;
    this.setState({ concepto });
  }

  guardarConcepto = () => {
    let { concepto, conceptos, comprobante } = this.state;
    const resultadoValidacion = this.validar_formulario_concepto(concepto);
    this.setState({ erroresRequeridos: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      conceptos.push(concepto);
      servicioIngresosDiversos.obtner_comprobante({ comprobante: comprobante, diversos: conceptos }).then(response => {
        this.setState({ modalConceptos: false, listaAtributos: [], conceptos: response.data.objeto.diversos, comprobante: response.data.objeto.comprobante });
      });
    }

  }

  editarConcepto = () => {
    const { concepto, comprobante, indexConcepto, conceptos } = this.state;
    const resultadoValidacion = this.validar_formulario_concepto(concepto);
    this.setState({ erroresRequeridos: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      conceptos[indexConcepto].cantidad = concepto.cantidad;
      conceptos[indexConcepto].concepto = concepto.concepto;
      conceptos[indexConcepto].costo = concepto.costo;
      conceptos[indexConcepto].total = concepto.total;
      conceptos[indexConcepto].ingresodiverso = concepto.ingresodiverso;
      conceptos[indexConcepto].atributos = concepto.atributos;
      conceptos[indexConcepto].descripcionDetallada = concepto.descripcionDetallada;
      servicioIngresosDiversos.obtner_comprobante({ comprobante: comprobante, diversos: conceptos }).then(response => {
        this.setState({ modalConceptos: false, listaAtributos: [], conceptos: response.data.objeto.diversos, comprobante: response.data.objeto.comprobante, botonEditarConcepto: false });
      });
    }
  }

  realizar_calculos_cantidad_total = () => {
    let { concepto } = this.state;
    servicioIngresosDiversos.realizar_calculos_cantidad_total(concepto).then(response => {
      if (response.data.error)
        this.growl.show({ life: 3000, severity: 'error', summary: 'error', detail: response.data.mensaje });
      else
        this.setState({ concepto: response.data.objeto });
    });
  }

  validar_formulario_concepto = (concepto) => {
    const erroresConcepto = {};
    if (!concepto.cantidad)
      erroresConcepto.cantidad = "Cantidad es requerida";

    if (!concepto.ingresodiverso || concepto.ingresodiverso === undefined)
      erroresConcepto.ingresodiverso = "Concepto requerido";

    if (!concepto.costo)
      erroresConcepto.costo = "Costo es requerida";

    return erroresConcepto;
  }

  columnaEditarConcepto = (rowData, column) => {
    return <div style={{ justifyContent: 'center' }}>
      <Button tooltip="Editar concepto" type="button" icon="pi-md-edit" className="p-button-warning" onClick={this.pre_editar.bind(this, rowData)}></Button>
      <Button tooltip="Eliminar concepto" type="button" icon="pi-md-delete" className="p-button-danger" onClick={this.pre_eliminar.bind(this, rowData)}></Button>
    </div>;
  }



  pre_editar = (objeto) => {
    let { concepto, listaAtributos, conceptos } = this.state;
    concepto = objeto;
    const index = conceptos.findIndex(con => con === objeto);

    this.lista_atributos(concepto, listaAtributos, true);

    this.setState({ concepto, indexConcepto: index, modalConceptos: true, botonEditarConcepto: true })
  }

  pre_eliminar = (objeto) => {
    let { conceptos, comprobante } = this.state;
    const index = conceptos.findIndex(con => con === objeto);
    conceptos.splice(index, 1);
    if (conceptos.length > 0) {
      servicioIngresosDiversos.obtner_comprobante({ comprobante: comprobante, diversos: conceptos }).then(response => {
        this.setState({ modalConceptos: false, listaAtributos: [], conceptos: response.data.objeto.diversos, comprobante: response.data.objeto.comprobante, botonEditarConcepto: false });
      });
    } else {
      this.setState({
        comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 }, conceptos: { concepto: [] } }
      });
    }

  }

  columnaEditarPagos = (rowData, column) => {
    return <div>
      <Button tooltip="Editar pago" type="button" icon="pi-md-edit" className="p-button-warning" onClick={this.pre_editar_pago.bind(this, rowData)}></Button>
    </div>;
  }

  pre_editar_pago = (objeto) => {
    let { pagos, doctoRelacionado } = this.state;
   // const indexPagos = pagos.findIndex(pago => pago === objeto);
    let pagosCopiado = JSON.parse(JSON.stringify(objeto));
    console.log(pagosCopiado);
    console.log(pagosCopiado.doctoRelacionado);
    let doctoCopiado = pagosCopiado.doctoRelacionado;
    delete pagosCopiado.doctoRelacionado;
    let pagoEditar = pagosCopiado;
    pagoEditar.fechaPago = new Date(pagoEditar.fechaPago);
 this.setState({ modalPagos: true, pagos: pagos, doctoRelacionado: doctoCopiado, botonEditarPago: true });

   
  }

  editarPago = () => {
    const { pago, doctoRelacionado, pagos, listaImpuestosTrasladados , listaImpuestosRetenciones} = this.state;
    const resultadoValidacion = this.validar_formulario_pago(pago, doctoRelacionado);
    this.setState({ erroresRequeridos: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {



      let objetoImpDR = doctoRelacionado.objetoImpDR;
      delete doctoRelacionado.objetoImpDR;
      doctoRelacionado.objetoImpDR = objetoImpDR.code;

     // let monedaDR = doctoRelacionado.monedaDR;
     // delete doctoRelacionado.monedaDR;
     // doctoRelacionado.monedaDR = monedaDR.code;

      if (doctoRelacionado.objetoImpDR === "02" || doctoRelacionado.objetoImpDR === "03") {
        doctoRelacionado.impuestosDR = {};

        if(!servicioObjetos.esObjetoVacio(listaImpuestosTrasladados)){
        doctoRelacionado.impuestosDR.trasladosDR = { "trasladoDR": [] };
        doctoRelacionado.impuestosDR.trasladosDR.trasladoDR = listaImpuestosTrasladados;
        }

        if(!servicioObjetos.esObjetoVacio(listaImpuestosRetenciones)){
          doctoRelacionado.impuestosDR.retencionesDR = { "retencionDR": [] };
          doctoRelacionado.impuestosDR.retencionesDR.retencionDR = listaImpuestosRetenciones;


        }


        this.calcularTotales();
      }


      delete doctoRelacionado.doctoRelacionado;

      pago.doctoRelacionado = doctoRelacionado;
      pagos['pago'] = [pago];
       this.setState({ pagos, modalPagos: false, modalPagos: false, botonEditarPago: false  });



    }

    
   // this.setState({ pagos, modalPagos: false, botonEditarPago: false });
  }

  nuevo_pago = () => {
    var pagoEditar = {};
    pagoEditar['monedaP'] = { name: 'MXN', code: 'MXN' };
    this.setState({ modalPagos: true, pago: pagoEditar, doctoRelacionado: {}, botonEditarPago: false });
  }

  guardarPago = () => {
    const { pago, doctoRelacionado, pagos, listaImpuestosTrasladados , listaImpuestosRetenciones} = this.state;
    const resultadoValidacion = this.validar_formulario_pago(pago, doctoRelacionado);
    
    this.setState({ erroresRequeridos: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {



      let objetoImpDR = doctoRelacionado.objetoImpDR;
      delete doctoRelacionado.objetoImpDR;
      doctoRelacionado.objetoImpDR = objetoImpDR.code;

      if (doctoRelacionado.objetoImpDR === "02" || doctoRelacionado.objetoImpDR === "03") {
        doctoRelacionado.impuestosDR = {};

        if(!servicioObjetos.esObjetoVacio(listaImpuestosTrasladados)){
        doctoRelacionado.impuestosDR.trasladosDR = { "trasladoDR": [] };
        doctoRelacionado.impuestosDR.trasladosDR.trasladoDR = listaImpuestosTrasladados;
        }

        if(!servicioObjetos.esObjetoVacio(listaImpuestosRetenciones)){
          doctoRelacionado.impuestosDR.retencionesDR = { "retencionDR": [] };
          doctoRelacionado.impuestosDR.retencionesDR.retencionDR = listaImpuestosRetenciones;


        }


        this.calcularTotales();
      }




      pago['doctoRelacionado'] = [doctoRelacionado];





      pagos['pago'] = [pago];

      this.setState({ pagos, modalPagos: false });



    }

  }

  calcularTotales = () => {

    const { doctoRelacionado, pago } = this.state;

    let mapImpuestoTrasladado = new Map();
    let mapImpuestoRetenido = new Map();


    let eldocumento = doctoRelacionado;

    if (eldocumento.objetoImpDR === "02" || eldocumento.objetoImpDR === "03") {

      if (!servicioObjetos.esObjetoVacio(eldocumento.impuestosDR.trasladosDR)) {


        for (let index = 0; index < eldocumento.impuestosDR.trasladosDR.trasladoDR.length; index++) {
          let trasladoDR = eldocumento.impuestosDR.trasladosDR.trasladoDR[index];

          if (!servicioObjetos.esObjetoVacio(trasladoDR.tipoFactorDR) && trasladoDR.tipoFactorDR === 'Exento') {
            trasladoDR.baseDR = eldocumento.impPagado;
            let llaveImpuestoDR = trasladoDR.impuestoDR + trasladoDR.tipoFactorDR;
            if (mapImpuestoTrasladado.has(llaveImpuestoDR)) {
              mapImpuestoTrasladado.get(llaveImpuestoDR).baseDR = mapImpuestoTrasladado.get(llaveImpuestoDR).baseDR + trasladoDR.baseDR;
            } else {
              let tras = JSON.parse(JSON.stringify(trasladoDR));
              mapImpuestoTrasladado.set(llaveImpuestoDR, tras);
            }

          }

          if (!servicioObjetos.esObjetoVacio(trasladoDR.tipoFactorDR) && trasladoDR.tipoFactorDR === 'Tasa' || trasladoDR.tipoFactorDR === 'Cuota') {
            let base = 0;
            

            if( trasladoDR.tasaOCuotaDR ==="0.160000" || trasladoDR.tasaOCuotaDR==="0.080000"||trasladoDR.tasaOCuotaDR==="0.000000"){
            if(trasladoDR.tasaOCuotaDR==="0.160000")
              base = pago.monto / 1.16;
            

            if(trasladoDR.tasaOCuotaDR==="0.080000")
              base = pago.monto / 1.08;
            

            if(trasladoDR.tasaOCuotaDR==="0.000000")
              base = pago.monto;
            
            if(trasladoDR.tipoFactorDR==="Cuota")
              base = pago.monto;
              //trasladoDR.tasaOCuotaDR="0.160000";
            
           // if(trasladoDR.impuestoDR==="003"){
              //base = pago.monto;
           // }
          }else{
            base = pago.monto;
          }


           

            trasladoDR.baseDR = servicioFormatos.redondearNumeroDosDecimales(base);
            trasladoDR.importeDR = servicioFormatos.redondearNumeroDosDecimales(trasladoDR.baseDR * trasladoDR.tasaOCuotaDR);

            let llaveImpuesto = trasladoDR.impuestoDR + trasladoDR.tipoFactorDR + trasladoDR.tasaOCuotaDR;
            if (mapImpuestoTrasladado.has(llaveImpuesto)) {
              mapImpuestoTrasladado.get(llaveImpuesto).baseDR = mapImpuestoTrasladado.get(llaveImpuesto).baseDR + trasladoDR.baseDR;
              mapImpuestoTrasladado.get(llaveImpuesto).importeDR = mapImpuestoTrasladado.get(llaveImpuesto).importeDR + trasladoDR.importeDR;
            } else {
              let tras = JSON.parse(JSON.stringify(trasladoDR));
              mapImpuestoTrasladado.set(llaveImpuesto, tras);
            }


          }




        }


      }


      ////inpuestos retenidos

      if (!servicioObjetos.esObjetoVacio(eldocumento.impuestosDR.retencionesDR)) {

        for (let index = 0; index < eldocumento.impuestosDR.retencionesDR.retencionDR.length; index++) {
          let retencionDR = eldocumento.impuestosDR.retencionesDR.retencionDR[index];

          if (!servicioObjetos.esObjetoVacio(retencionDR.tipoFactorDR) && retencionDR.tipoFactorDR === 'Exento') {
            retencionDR.baseDR = eldocumento.impPagado;
            let llaveImpuestoDR = retencionDR.impuestoDR + retencionDR.tipoFactorDR;
            if (mapImpuestoRetenido.has(llaveImpuestoDR)) {
              mapImpuestoRetenido.get(llaveImpuestoDR).baseDR = mapImpuestoRetenido.get(llaveImpuestoDR).baseDR + retencionDR.baseDR;
            } else {
              let ret = JSON.parse(JSON.stringify(retencionDR));
              mapImpuestoRetenido.set(llaveImpuestoDR, ret);
            }

          }

          if (!servicioObjetos.esObjetoVacio(retencionDR.tipoFactorDR) && retencionDR.tipoFactorDR === 'Tasa' || retencionDR.tipoFactorDR === 'Cuota') {
            let base = 0;

            //base = pago.monto / 1.16;

            retencionDR.baseDR = servicioFormatos.redondearNumeroDosDecimales(pago.monto);
            retencionDR.importeDR = servicioFormatos.redondearNumeroDosDecimales(retencionDR.baseDR * retencionDR.tasaOCuotaDR);

            let llaveImpuesto = retencionDR.impuestoDR + retencionDR.tipoFactorDR + retencionDR.tasaOCuotaDR;
            if (mapImpuestoRetenido.has(llaveImpuesto)) {
              mapImpuestoRetenido.get(llaveImpuesto).baseDR = mapImpuestoRetenido.get(llaveImpuesto).baseDR + retencionDR.baseDR;
              mapImpuestoRetenido.get(llaveImpuesto).importeDR = mapImpuestoRetenido.get(llaveImpuesto).importeDR + retencionDR.importeDR;
            } else {
              let ret = JSON.parse(JSON.stringify(retencionDR));
              mapImpuestoRetenido.set(llaveImpuesto, ret);
            }


          }




        }
      }




    }





    //
    this.agregarImpuestosGlobales(mapImpuestoTrasladado, mapImpuestoRetenido);


  }

  agregarImpuestosGlobales = (mapImpuestoTrasladado, mapImpuestoRetenido) => {
    let { pago, impuestosP, pagos } = this.state;
    let totales = {};

    if (!servicioObjetos.esObjetoVacio(mapImpuestoTrasladado.values().next().value)) {
      if (servicioObjetos.esObjetoVacio(impuestosP))
        impuestosP = {}

      impuestosP.trasladosP = { trasladoP: [] }

    }

    mapImpuestoTrasladado.forEach((value, key) => {
      let trasladoDR = value;
      if (!servicioObjetos.esObjetoVacio(trasladoDR.importeDR)) {
        // <pago20:Totales TotalTrasladosBaseIVA16="0.86" TotalTrasladosImpuestoIVA16="0.14" MontoTotalPagos="1.00"/>
        //if (servicioObjetos.esObjetoVacio(pago.totales))
        //TotalTrasladosBaseIVA16="86.20" TotalTrasladosImpuestoIVA16="13.79" MontoTotalPagos="100.00"

        if (trasladoDR.tasaOCuotaDR === "0.160000") {
          totales.totalTrasladosBaseIVA16 = 0;
          totales.totalTrasladosImpuestoIVA16 = 0;
          totales.totalTrasladosImpuestoIVA16 = totales.totalTrasladosImpuestoIVA16 + trasladoDR.importeDR;
          totales.totalTrasladosBaseIVA16 = totales.totalTrasladosBaseIVA16 + trasladoDR.baseDR;

        }
        if (trasladoDR.tasaOCuotaDR === "0.080000") {
          totales.totalTrasladosImpuestoIVA8 = 0;
          totales.totalTrasladosBaseIVA8 = 0;
          totales.totalTrasladosImpuestoIVA8 = totales.totalTrasladosImpuestoIVA8 + trasladoDR.importeDR;
          totales.totalTrasladosBaseIVA8 = totales.totalTrasladosBaseIVA8 + trasladoDR.baseDR;

        }

        if (trasladoDR.tasaOCuotaDR === "0.000000") {
          totales.totalTrasladosBaseIVA0 = 0;
          totales.totalTrasladosImpuestoIVA0 = 0;
          totales.totalTrasladosImpuestoIVA0 = totales.totalTrasladosImpuestoIVA0 + trasladoDR.importeDR;
          totales.totalTrasladosBaseIVA0 = totales.totalTrasladosBaseIVA0 + trasladoDR.baseDR;
        }

       


        





      }

      if (trasladoDR.tipoFactorDR === "Exento") {
        
        totales.totalTrasladosBaseIVAExento = 0;
        totales.totalTrasladosBaseIVAExento = totales.totalTrasladosBaseIVAExento + trasladoDR.baseDR;
      }


      let trasladoP = {};
      trasladoP.baseP = value.baseDR;
      trasladoP.impuestoP = value.impuestoDR;
      trasladoP.tipoFactorP = value.tipoFactorDR;
      trasladoP.tasaOCuotaP = value.tasaOCuotaDR;
      trasladoP.importeP = value.importeDR;

      impuestosP.trasladosP.trasladoP.push(trasladoP);
    });



    /////mapa retenciones

    if (!servicioObjetos.esObjetoVacio(mapImpuestoRetenido.values().next().value)) {
      if (servicioObjetos.esObjetoVacio(impuestosP))
        impuestosP = {}

      impuestosP.retencionesP = { retencionP: [] }

    }

    mapImpuestoRetenido.forEach((value, key) => {
      let retencionDR = value;
      if (!servicioObjetos.esObjetoVacio(retencionDR.importeDR)) {
        // <pago20:Totales TotalTrasladosBaseIVA16="0.86" TotalTrasladosImpuestoIVA16="0.14" MontoTotalPagos="1.00"/>
        //if (servicioObjetos.esObjetoVacio(pago.totales))
        //TotalTrasladosBaseIVA16="86.20" TotalTrasladosImpuestoIVA16="13.79" MontoTotalPagos="100.00"



        /////isr
        if (retencionDR.impuestoDR === "001") {
          
          totales.totalRetencionesISR = 0;
          totales.totalRetencionesISR = totales.totalRetencionesISR + retencionDR.importeDR;
         

        }
       //////iva
        if (retencionDR.impuestoDR === "002") {

          totales.totalRetencionesIVA = 0;
          totales.totalRetencionesIVA = totales.totalRetencionesIVA + retencionDR.importeDR;
        }
//////// ieps
        if (retencionDR.impuestoDR === "003") {

          totales.totalRetencionesIEPS = 0;
          totales.totalRetencionesIEPS = totales.totalRetencionesIEPS + retencionDR.importeDR;
        }


     

      

      






      }

      let retencionP = {};
    
      retencionP.impuestoP = value.impuestoDR;
     
      
      retencionP.importeP = value.importeDR;

      impuestosP.retencionesP.retencionP.push(retencionP);
    });


    /////




    totales.montoTotalPagos = pago.monto;
    pagos.totales = totales;
    this.setState({ pagos });





    pago.impuestosP = impuestosP;

    // if (!servicioObjetos.esObjetoVacio(mapImpuestoTrasladado.values().next().value)) {
    //  if (servicioObjetos.esObjetoVacio(pago.impuestosP))
    //  pago.impuestosP={};

    // impuestos.totalImpuestosTrasladados = null;

    //  console.log("entra agregar impuestos globales")
    //}
  }

   eliminarTraslados = (rowData) =>{
    
    let { listaImpuestosTrasladados} = this.state;
    ServicioObjetos.eliminarObjetoColeccion(listaImpuestosTrasladados,rowData);
    this.setState({ listaImpuestosTrasladados });
}

eliminarRetenciones = (rowData) =>{
  let { listaImpuestosRetenciones} = this.state;
  ServicioObjetos.eliminarObjetoColeccion(listaImpuestosRetenciones,rowData);
  this.setState({ listaImpuestosRetenciones });
}




  columna_valor_unitario = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.valorUnitario)}</div>;
  }

  columna_valor_monto = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.monto)}</div>;
  }

  columna_valor_fecha_pago = (rowData, column) => {
    return <div>{servicioFormatos.formatearFechaString(rowData.fechaPago)}</div>;
  }
  columna_costo = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.importe)}</div>;

  }

  total_iva = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.totalIva)}</div>;
  }

  total_retenido = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.iva)}</div>

  }

  total_retenido_isr = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.isr)}</div>

  }

  total = (rowData, column) => {
    return <div style={{ backgroundColor: '#00bcd4' }}>{servicioFormatos.formatearModena(rowData.totalSumaIva)}</div>;
  }

  prefactura = () => {
    let { receptor, conceptos, tipoDeComprobante, formaPago, metodoPago, banderaPagos, informacionGlobal } = this.state;
    const errores = this.validar_facturacion(receptor, conceptos, tipoDeComprobante, formaPago, metodoPago, banderaPagos, informacionGlobal);
    this.setState({ erroresFrmDatos: errores });
    if (!Object.keys(errores).length) {
      let erroresFrmDatosFiscales = this.validarFomularioDatosFiscales();
      this.setState({ erroresFrmDatosFiscales: erroresFrmDatosFiscales });
      if (!Object.keys(erroresFrmDatosFiscales).length) {
        let receptorEnvio = { rfc: receptor.rfc, nombre: receptor.nombre, domicilioFiscalReceptor: receptor.domicilioFiscalReceptor, regimenFiscalReceptor: receptor.regimenFiscalReceptor.id, usoCfdi: receptor.usoCfdi.id };

        if (receptor.rfc === 'XAXX010101000') {
          this.setState({ confirmacionFacturacion: true, listaReceptorConfirmacion: [receptor] });
        } else {


          servicioHttp.consumirPostHttp("receptor/validar_receptor40.json", receptorEnvio).then(response => {
            let validacionDatosFiscales = response.data.error;
            if (validacionDatosFiscales) {
              this.growl.show({ severity: 'error', summary: 'Error', detail: response.data.mensaje, life: 5000 });
            } else {
              this.setState({ confirmacionFacturacion: true, listaReceptorConfirmacion: [receptor] });
            }
          })
        }




        ///

      }





    }
  }

  validarFomularioDatosFiscales = () => {
    let errores = {};
    let { receptor } = this.state;
    

    if (!receptor.rfc)
      errores.rfc = "El rfc del receptor es requerido";
    if (!receptor.nombre)
      errores.nombre = "El nombre del receptor es requerido";
    if (!receptor.usoCfdi)
      errores.usoCfdi = "El uso Cfdi es requerido";
    if (!receptor.correo) {
      errores.correo = "El correo es requerido";
    } else {
      this.validarCorreo(receptor.correo, errores);
    }
    if (servicioAsignacionValoresObjetos.esObjetoVacio(receptor.domicilioFiscalReceptor))
      errores.domicilioFiscalReceptor = "El Domicilio Fiscal es requerido";
    if (servicioAsignacionValoresObjetos.esObjetoVacio(receptor.regimenFiscalReceptor))
      errores.regimenFiscalReceptor = "El Regimen Fiscal es requerido";
    return errores;
  }

  validarCorreo = (correo, errores) => {
    var patronCorreo = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const valorvalidacion = patronCorreo.exec(correo);
    if (null === valorvalidacion)
      errores.correo = "Ingrese un correo valido";
  }

  validar_facturacion = (receptor, conceptos, tipoDeComprobante, formaPago, metodoPago, banderaPagos, informacionGlobal) => {
    const erroresConcepto = {};
    const mensajesError = [];
    if (!receptor.rfc) {
      erroresConcepto.rfc = "El receptor es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Receptor', detail: erroresConcepto.rfc });
    }

    if (!banderaPagos) {
      if (conceptos.length === 0) {
        erroresConcepto.conceptos = "Debes agregar un concepto requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Concepto', detail: erroresConcepto.conceptos });
      }

      if (!formaPago.name) {
        erroresConcepto.formaPago = "La forma de pago es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Forma de Pago', detail: erroresConcepto.formaPago });
      }

      if (!metodoPago.name) {
        erroresConcepto.metodoPago = "El método de pago es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Método de Pago', detail: erroresConcepto.metodoPago });
      }
    }

    if (!receptor.usoCfdi) {
      erroresConcepto.usoCfdi = "El uso del CFDI es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message usoCfdi', detail: erroresConcepto.usoCfdi });
    }

    if (!receptor.regimenFiscalReceptor) {
      erroresConcepto.regimenFiscalReceptor = "El Regimen Fiscal es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message usoCfdi', detail: erroresConcepto.regimenFiscalReceptor });
    }

    if (!tipoDeComprobante.name) {
      erroresConcepto.tipoDeComprobante = "El tipo de comprobante es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Tipo de Comprobante', detail: erroresConcepto.tipoDeComprobante });
    }


    if (!servicioAsignacionValoresObjetos.esObjetoVacio(receptor.rfc) && receptor.rfc === "XAXX010101000") {

      
    
      if (servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal.periodicidad)) {
        erroresConcepto.periodicidad = "Periodicidad es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Periodicidad', detail: erroresConcepto.periodicidad });

      }

      if (servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal.meses)) {
        erroresConcepto.meses = "Meses es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Meses', detail: erroresConcepto.meses });
      }

      if (servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal.anio)) {
        erroresConcepto.anio = "Año es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Año', detail: erroresConcepto.anio });
      }

    }

    if (Object.keys(erroresConcepto).length) {
      this.growl.show(mensajesError);
    }
    return erroresConcepto;
  }



  facturar = () => {
    const { comprobante, receptor, conceptos, tipoDeComprobante, formaPago, mostrarCfdiRelacionado, tiporelacion, folioFiscal,
      metodoPago, pagos, pago, informacionGlobal } = this.state;
    
    
    var receptorEnvio = JSON.parse(JSON.stringify(receptor));
    let usoCfdi = receptorEnvio.usoCfdi.id;
    delete receptorEnvio['usoCfdi'];
    receptorEnvio.usoCfdi = usoCfdi;
    let regimenFiscalReceptor = receptorEnvio.regimenFiscalReceptor.id;
    delete receptorEnvio['regimenFiscalReceptor'];
    receptorEnvio.regimenFiscalReceptor = regimenFiscalReceptor;
    comprobante['tipoDeComprobante'] = tipoDeComprobante.code;
    if (comprobante.tipoDeComprobante === "P") {
      comprobante["formaPago"] = null;
      comprobante["condicionesDePago"] = null;
      comprobante["subTotal"] = 0;
      comprobante["descuento"] = null;
      comprobante["moneda"] = "XXX";
      comprobante["tipoCambio"] = null;
      comprobante["total"] = 0;
      comprobante["metodoPago"] = null;
      comprobante["conceptos"] = { concepto: [{ "claveProdServ": "84111506", "cantidad": 1, "claveUnidad": "ACT", "descripcion": "Pago", "valorUnitario": 0, "importe": 0, "objetoImp": "01" }] }
    } else {
      comprobante['formaPago'] = formaPago.code;
      comprobante['metodoPago'] = metodoPago.code;
    }
    if (mostrarCfdiRelacionado) {
      comprobante['cfdiRelacionados'] = [{ cfdiRelacionado: [{ uuid: folioFiscal.uuid }], tipoRelacion: tiporelacion.code }]

      // comprobante['cfdiRelacionados'] = [{ "tipoRelacion": tiporelacion.code, cfdiRelacionado: [{ uuid: folioFiscal.uuid }] }];
    }
    let pagosEnvio = {};
    let totales = {};
    pagosEnvio.totales = pagos.totales;

    if (pagos.pago !== undefined) {
      let pagosResquest = JSON.parse(JSON.stringify(pagos.pago));
      if (pagosResquest.length === 0) {
        pagosEnvio = null;
      } else {
        for (var i = 0; i < pagosResquest.length; i++) {
          
          let monedaP = pagosResquest[i].monedaP;
          delete pagosResquest[i].monedaP;
          pagosResquest[i]['monedaP'] = monedaP.code;
          if (monedaP.code === "MXN") {
            pagosResquest[i]['tipoCambioP'] = "1";
          }


          let formaDePagoP = pagosResquest[i].formaDePagoP;
          delete pagosResquest[i].formaDePagoP;
          pagosResquest[i]['formaDePagoP'] = formaDePagoP.code;
          let doctoRelacionado = pagosResquest[i].doctoRelacionado
          for (var j = 0; j < doctoRelacionado.length; j++) {
         
         
            let monedaDR = doctoRelacionado[j].monedaDR;
           
            // let objetoImpDR = doctoRelacionado[j].objetoImpDR;
            delete doctoRelacionado[j].monedaDR;
            //  delete doctoRelacionado[j].objetoImpDR;
            
            doctoRelacionado[j]['monedaDR'] = monedaDR.code;
            doctoRelacionado[j]['equivalenciaDR'] = "1";
            // doctoRelacionado[j]['objetoImpDR'] = objetoImpDR.code;
          }

        }

        pagosEnvio.pago = pagosResquest;

        // pagosEnvio={pago:pagosResquest};

      }
    } else {
      pagosEnvio = null;
    }

    

    if (!servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal)) {
      let informacionGlobalEnvio = JSON.parse(JSON.stringify(informacionGlobal));
      comprobante['informacionGlobal'] = { periodicidad: informacionGlobalEnvio.periodicidad.id, meses: informacionGlobalEnvio.meses.id, anio: new Date(informacionGlobalEnvio.anio).getFullYear() }
    }

    servicioIngresosDiversos.facturar_comprobante({ comprobante: comprobante, receptor: receptorEnvio, diversos: conceptos, pagos: pagosEnvio }).then(response => {
      let respuesta = response.data;
      let listaResultados = respuesta.lista;
      this.setState({ mostrarModalResultado: true, confirmacionFacturacion: false, listaResultados: listaResultados });
      if (listaResultados[0].error === false) {
        this.setState({listaImpuestosRetenciones:[],listaImpuestosTrasladados:[], objetoTasaOcuotaTraslado:{}, objetoImpuesto:{},objetoTasaoCuota:{},
          comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 }, conceptos: { concepto: [] } },
          conceptos: [], receptor: {}, listaReceptor: [], listaTabla: [], listaReceptorConfirmacion: [], tipoDeComprobante: {}, formaPago: {}, metodoPago: {}, mostrarCfdiRelacionado: false,
          tiporelacion: {}, folioFiscal: {}, banderaPagos: false, pago: {}, doctoRelacionado: {}, pagos: [], informacionGlobal: {}
        });
      }



    })


  }

  cerrar_modal_confirmacion_facturacion = () => {
    this.setState({ confirmacionFacturacion: false });
  }

  cerrarModalResultados = () => {
    this.setState({ mostrarModalResultado: false });
  }

  templateDescargaArchivos = (rowData, column) => {
    if (rowData.error === false)
      return <div><Button type="button" icon="pi-md-cloud-download" className="p-button-success" onClick={(e) => this.descargaArchivos(rowData)}></Button></div>;
  }

  descargaArchivos = (rowData) => {
    let { urlDescargaArchivosFacturacion } = this.state;
    servicioDescargaArchivos.descargaArchivo(urlDescargaArchivosFacturacion, { id: rowData.objeto.busqueda });
  }

  columna_uso_cfdi = (rowData, column) => {
    return (
      <div className="p-clearfix">
        <span >{rowData.usoCfdi.id} - {rowData.usoCfdi.descripcion}</span>
      </div>
    );

  }

  templateErrorResultado = (rowData, column) => {
    if (rowData.error === true)
      return <div className="p-col-12 p-md-2"><i className="pi-md-cancel"></i></div>;
    else
      return <div className="p-col-12 p-md-2"><i className="pi-md-check-circle"></i></div>;
  }

  crearCfdiRelacionado = (e) => {
    this.setState({ mostrarCfdiRelacionado: e.checked, folioFiscal: {}, tiporelacion: {} });
  }


  cerrarModalPagos = () => {
    this.setState({ modalPagos: false, erroresRequeridos: {}, botonEditarPago: false });
  }

  cerrarModalImpuestosTraslados = () => {
    this.setState({ modalImpuestoTraslados: false });
  }

  validar_formulario_pago = (pago, doctoRelacionado) => {

    let { objetoImpuesto , listaImpuestosRetenciones, listaImpuestosTrasladados} = this.state;
  

    const erroresConcepto = {};
    if (!pago.fechaPago || pago.fechaPago === undefined)
      erroresConcepto.fechaPago = "fecha Pago es requerida";

    if (!pago.formaDePagoP || pago.formaDePagoP === undefined)
      erroresConcepto.formaDePagoP = "formaDePagoP requerido";

    if (!pago.monto)
      erroresConcepto.monto = "monto es requerido";

    if (!doctoRelacionado.idDocumento)
      erroresConcepto.idDocumento = "uuid es requerido"

    if (!doctoRelacionado.monedaDR || doctoRelacionado.monedaDR === undefined)
      erroresConcepto.monedaDR = "monedaDR es requerido"

    if(servicioObjetos.esObjetoVacio(doctoRelacionado.objetoImpDR))
    erroresConcepto.objetoImpuesto = "El objeto impuesto es requerido"

      

      if(objetoImpuesto === "02" || objetoImpuesto === "03" ){
        var bandera_pago = "true";
       
        if(!servicioObjetos.esObjetoVacio(listaImpuestosRetenciones)){
        
          var bandera_pago = "false";
        }
    
        if(!servicioObjetos.esObjetoVacio(listaImpuestosTrasladados)){
         
          var bandera_pago = "false";
        }

        if(bandera_pago==="true"){

        
          erroresConcepto.impuestos = "Es requerido un traslado o una retención";
        }
    
      }

    

    // if (!doctoRelacionado.objetoImpDR )
    // erroresConcepto.objetoImpDR = "objetoImpDR es requerido"

    return erroresConcepto;
  }
  obtener_regimen_fiscal = () => {
    let { receptor } = this.state;
    servicioHttp.consumirPostHttpBasic('regimen/buscar_regimen_fiscal_uso_cfdi.json', {
      'rfc': receptor.rfc,
      'usoCfdi': receptor.usoCfdi.clave
    }).then(response => {
      this.setState({ listaRegimenFiscalReceptor: response.data.lista });
    });
  }

  consultaImpuestoTrasladado = () => {
    servicioHttp.consumirPostHttp("impuestos/buscar_impuesto_trasladado.json").then(response => {

      this.setState({ listaimpuestoTrasladado: response.data.lista });


    });
  };

  consultaTipoFactor = () => {
    servicioHttp.consumirPostHttp("impuestos/buscar_tipo_factor.json").then(response => {

      this.setState({ listaTipoFactor: response.data.lista });

    });
  }

  buscarTasaOCuota = () => {
    let { trasladoDR, objetoTasaOcuotaTraslado } = this.state;

    servicioHttp.consumirPostHttp("/impuestos/buscar_tasa_cuota.json", { impuesto: trasladoDR.impuestoDR.descripcion, factor: trasladoDR.tipoFactorDR.id }).then(response => {
      this.setState({ listaTasaoCuota: response.data.lista });

      this.setState({objetoTasaOcuotaTraslado:{}});
      if (response.data.lista.length === 1) {
        objetoTasaOcuotaTraslado = response.data.lista[0];
        this.setState({ objetoTasaOcuotaTraslado});
    }

    });

  }

  consultaImpuestoRetenido = () => {
    servicioHttp.consumirPostHttp("facturacion/buscar_impuesto_retenido.json").then(response => {
      this.setState({ listaimpuestoRetencion: response.data.lista });

    });
};

consultaTipoFactorRetenido = () => {

    servicioHttp.consumirPostHttp("/facturacion/buscar_tipo_factor_retenido.json").then(response => {
      this.setState({ listaTipoFactorRetenido: response.data.lista });

      
    });
}

 buscarTasaOCuotaRetenido = () => {
  let { retencionDR ,objetoTasaoCuota} = this.state;
  servicioHttp.consumirPostHttp("facturacion/buscar_tasa_cuota_retenido.json", { impuesto: retencionDR.impuestoDR.descripcion, factor: retencionDR.tipoFactorDR.id }).then(response => {
    this.setState({ listaTasaoCuotaRetenido: response.data.lista });
    this.setState({ objetoTasaoCuota:{} });
    if (response.data.lista.length === 1) {
      objetoTasaoCuota= response.data.lista[0];
      this.setState({ objetoTasaoCuota });
     
      
  }
     
  });

 }

abrirModalImpuestoRetenido = () =>{
  this.setState({ modalImpuestoRetenidos: true });
  this.consultaImpuestoRetenido();
  this.consultaTipoFactorRetenido();

}
cerrarModalImpuestosRetenidos = () =>{
  this.setState({ modalImpuestoRetenidos: false });
}




  abrirModalImpuestoTraslado = () => {

    this.setState({ modalImpuestoTraslados: true });
    this.consultaImpuestoTrasladado();
    this.consultaTipoFactor();

  }

  cerrarModalTraslado = () => {
    this.setState({ modalImpuestoTraslados: false }, );
  }
  validarFormularioTraslado =() =>{
    let { trasladoDR } = this.state;
    const validaciones = {};

      if (servicioObjetos.esObjetoVacio(trasladoDR.impuestoDR))
             validaciones.impuesto ="Campo requerido";
      if (servicioObjetos.esObjetoVacio(trasladoDR.tipoFactorDR))
             validaciones.impuesto ="Campo requerido";




    return validaciones;

  }

  validarFormularioRetenciones =()=>{
    let { retencionDR } = this.state;
    const validaciones = {};

      if (servicioObjetos.esObjetoVacio(retencionDR.impuestoDR))
             validaciones.impuesto ="Campo requerido";
      if (servicioObjetos.esObjetoVacio(retencionDR.tipoFactorDR))
             validaciones.impuesto ="Campo requerido";




    return validaciones;

  }



  guardarTraslado = () => {
    let { trasladoDR, listaImpuestosTrasladados } = this.state;

    let validacionFormulario = this.validarFormularioTraslado();
    this.setState({ validacionFormulario });
    if (servicioObjetos.esObjetoVacio(validacionFormulario)) {


    let trasladoCopia = JSON.parse(JSON.stringify(trasladoDR));
    let impuestoDR = trasladoCopia.impuestoDR.id;
    delete trasladoCopia.impuestoDR;
    trasladoCopia.impuestoDR = impuestoDR;

    let tasaOCuotaDR = null;
    if (typeof trasladoCopia.tasaOCuotaDR === 'object')
      tasaOCuotaDR = trasladoCopia.tasaOCuotaDR.descripcion;
    else
      tasaOCuotaDR = trasladoCopia.tasaOCuotaDR;

    delete trasladoCopia.tasaOCuotaDR;
    trasladoCopia.tasaOCuotaDR = tasaOCuotaDR;

    let tipoFactorDR = trasladoCopia.tipoFactorDR.id;
    delete trasladoCopia.tipoFactorDR;
    trasladoCopia.tipoFactorDR = tipoFactorDR;




    listaImpuestosTrasladados.push(trasladoCopia);
    this.setState({ listaImpuestosTrasladados });
    this.setState({ trasladoDR: {} });
    this.cerrarModalTraslado();
    }


  }

   guardarretencion = () => {
    let { retencionDR, listaImpuestosRetenciones } = this.state;
    let validacionFormulario = this.validarFormularioRetenciones();
    this.setState({ validacionFormulario });
    if (servicioObjetos.esObjetoVacio(validacionFormulario)) {
    
        let retencionCopia = JSON.parse(JSON.stringify(retencionDR));
        let impuestoDR=retencionCopia.impuestoDR.id;
        delete retencionCopia.impuestoDR;
        retencionCopia.impuestoDR=impuestoDR;

        let tasaOCuotaDR=null;
        if (typeof retencionCopia.tasaOCuotaDR === 'object')
        tasaOCuotaDR=retencionCopia.tasaOCuotaDR.descripcion;
        else
        tasaOCuotaDR=retencionCopia.tasaOCuotaDR;

        delete retencionCopia.tasaOCuotaDR;
        retencionCopia.tasaOCuotaDR=tasaOCuotaDR;

        let tipoFactorDR=retencionCopia.tipoFactorDR.id;
        delete retencionCopia.tipoFactorDR;
        retencionCopia.tipoFactorDR=tipoFactorDR;

        

       
        listaImpuestosRetenciones.push(retencionCopia);
        this.setState({ listaImpuestosRetenciones });
        this.setState({ retencionDR: {} });
        this.cerrarModalImpuestosRetenidos();
    
}}




  itemTemplateIdDescripcion = (item) => {
    return (<div><strong>{item.id}</strong> - <strong>{item.descripcion}</strong></div>);
  }

  itemTemplateDescripcion = (item) => {
    return (<div><strong>{item.descripcion}</strong></div>);
  }

  itemTemplateTipoFactor = (item) => {
    return (<div><strong>{item.id}</strong></div>);
  }

  itemTemplateId = (item) => {
    return (<div><strong>{item.id}</strong></div>);
  }

  templateImpuesto = (rowData, column) => {
    return rowData.impuestoDR;
  }

  templateTasaOCuota = (rowData, column) => {
    if (typeof rowData.tasaOCuotaDR === 'object')
      return rowData.tasaOCuotaDR.descripcion;
    else
      return rowData.tasaOCuotaDR;
  }

  templateTipoFactor = (rowData, column) => {
    return rowData.tipoFactorDR;
  }

  templateOpcionesTraslados = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi-md-delete" className="p-button-warning" onClick={() => this.eliminarTraslados(rowData)} />
    </div>;
  }

  templateOpcionesRetenidos = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi-md-delete" className="p-button-warning" onClick={() => this.eliminarRetenciones(rowData)} />
    </div>;
  }

  


  render() {
    let {objetoTasaOcuotaTraslado,objetoTasaoCuota, listaImpuestosRetenciones, listaTasaoCuotaRetenido, listaTipoFactorRetenido,listaimpuestoRetencion, retencionDR, listaImpuestosTrasladados, listaimpuestoTrasladado, trasladoDR, errores, listaTasaoCuota, receptor, listaTipoFactor, erroresRequeridos, erroresFrmDatos, concepto, listaMateriales, listaAtributos, botonEditarConcepto, comprobante, listaReceptorConfirmacion,
      mostrarModalResultado, listaResultados, mostrarCfdiRelacionado, apartadoCfdiRelacionado, folioFiscal, banderaPagos, pago,
      doctoRelacionado, urlRegimenFiscal, erroresFrmDatosFiscales, urlBusquedaReceptor, urlBusquedaUsosCfdi, informacionGlobal, objetoImpuesto } = this.state;

    const dialogFooterConcepto = (
      <div>
        {botonEditarConcepto ? <Button icon="pi-md-check" onClick={this.editarConcepto} label="Editar" className="teal-btn flat-btn" /> : <Button icon="pi-md-check" onClick={this.guardarConcepto} label="Guardar" className="teal-btn flat-btn" />}
        <Button icon="pi-md-close" onClick={() => this.setState({ concepto: { cantidad: 0.00, unidad: "PEAJE", costo: 0.0, atributos: {} }, modalConceptos: false })} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    const dialogFooterPago = (
      <div>
        {this.state.botonEditarPago ? <Button icon="pi-md-check" onClick={this.editarPago} label="Editar" className="teal-btn flat-btn" /> :
          <Button icon="pi-md-check" onClick={this.guardarPago} label="Guardar" className="teal-btn flat-btn" />}
        <Button icon="pi-md-close" onClick={this.cerrarModalPagos.bind(this)} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    const dialogModalImpuestoTraslados = (
      <div>

        <Button icon="pi-md-check" onClick={this.guardarTraslado} label="Guardar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrarModalTraslado.bind(this)} label="Cancelar" className="p-button-danger flat-btn" />
      </div>

    );

    const  dialogModalImpuestoRetenido  =(
      <div>
        <Button icon="pi-md-check" onClick={this.guardarretencion} label="Guardar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrarModalImpuestosRetenidos.bind(this)} label="Cancelar" className="p-button-danger flat-btn" />

      </div>

    );


    const formasPagos = [
      { name: '01-Efectivo', code: '01' },
      { name: '02-Cheque nominativo', code: '02' },
      { name: '03-Transferencia electrónica de fondos', code: '03' },
      { name: '04-Tarjeta de crédito', code: '04' },
      { name: '05-Monedero electrónico', code: '05' },
      { name: '06-Dinero electrónico', code: '06' },
      { name: '08-Vales de despensa', code: '07' },
      { name: '12-Dación en pago', code: '12' },
      { name: '13-Pago por subrogación', code: '13' },
      { name: '14-Pago por consignación', code: '14' },
      { name: '15-Condonación', code: '15' },
      { name: '17-Compensación', code: '17' },
      { name: '23-Novación', code: '23' },
      { name: '24-Confusión', code: '24' },
      { name: '25-Remisión de deuda', code: '25' },
      { name: '26-Prescripción o caducidad', code: '26' },
      { name: '27-A satisfacción del acreedor', code: '27' },
      { name: '28-Tarjeta de débito', code: '28' },
      { name: '29-Tarjeta de servicios', code: '29' },
      { name: '30-Aplicación de anticipos', code: '30' },
      { name: '31-Intermediario pagos', code: '31' },
      { name: '99-Por definir', code: '99' }
    ];

    const facturas = [
      { name: 'Ingreso', code: 'I' },
      { name: 'Egreso', code: 'E' },
      { name: 'Pago', code: 'P' }
    ];

    const metodosPago = [
      { name: 'PUE', code: 'PUE' },
      { name: 'PPD', code: 'PPD' }
    ];

    const monedasDR = [
      { name: 'MXN', code: 'MXN' },
      { name: 'USD', code: 'USD' }
    ];
    const objetosIMpuesto = [{ name: '01 - No objeto de impuesto', code: '01' }, { name: '02 - Sí objeto de impuesto', code: '02' }, { name: '03 - Sí objeto de impuesto y no obligado al desglose', code: '03' }];

    // const objetoImpDR = [
    //   { name: '01-No objeto de impuesto', code: '01' },
    //   { name: '02-Sí objeto de impuesto', code: '02' },
    //   { name: '03-Sí objeto del impuesto y no obligado al desglose', code: '03' }
    // ];

    const dialogFooterConfirmacionFacturacion = (
      <div>
        <Button icon="pi-md-check" onClick={this.facturar} label="Facturar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrar_modal_confirmacion_facturacion} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    const piePaginaModalRestultados = (
      <div>
        <Button label="Cerrar" icon="pi pi-times" onClick={this.cerrarModalResultados} />
      </div>
    );

    const tiposRelacion = [
      { name: "01-Nota de crédito de los documentos relacionados", code: "01" },
      { name: "02-Nota de débito de los documentos relacionados", code: "02" },
      { name: "03-Devolución de mercancía sobre facturas o traslados previos", code: "03" },
      { name: "04-Sustitución de los CFDI previos", code: "04" },
      { name: "05-Traslados de mercancias facturados previamente", code: "05" },
      { name: "06-Factura generada por los traslados previos", code: "06" },
      { name: "07-CFDI por aplicación de anticipo", code: "07" },
      { name: "08-Factura generada por pagos en parcialidades", code: "08" },
      { name: "09-Factura generada por pagos diferidos", code: "09" }];

    return (<div>
      <div className="content-section implementation">
        <Growl ref={(el) => this.growl = el} />
        <div className="card card-w-title">
          <h1 style={{ marginBottom: '30px' }}>Facturación Otros Ingresos</h1>
          <Receptor receptor={receptor} erroresFrmDatosFiscales={erroresFrmDatosFiscales} urlBusquedaReceptor={urlBusquedaReceptor} urlRegimenFiscal={urlRegimenFiscal} urlBusquedaUsosCfdi={urlBusquedaUsosCfdi} actualizaReceptor={this.actualizaReceptor} actualizaErroresFrmDatosFiscales={this.actualizaErroresFrmDatosFiscales} />
          <br />
          {/* <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-2" style={{textAlign:'center'}}>
              <label htmlFor="autocomplete"><strong>RFC Receptor:</strong></label>
            </div>
            <div className="p-col-12 p-md-6">
              <AutoComplete minLength={1} placeholder="Escribe el RFC de receptor y seleccionalo" id="autocomplete" field="descripcion" suggestions={this.state.valorencontrado}
                completeMethod={this.buscarReceptorLike} value={this.state.listaReceptor}
                onChange={this.cargarValores.bind(this)} className={erroresFrmDatos.rfc ? 'p-error' : ''}
              />
              {erroresFrmDatos.rfc ? <div><br /> <Message severity="error" text={erroresFrmDatos.rfc} /> </div> : null}
            </div>
            <div className="p-col-12" style={{marginTop:'20px'}}>
              <DataTable value={listaTabla} header="DATOS DEL RECEPTOR" responsive={true}>
                <Column style={{textAlign:'center'}} header="Editar" body={this.columnaEditarReceptor} autoLayout={true} />
                <Column style={{textAlign:'center'}} field="rfc" header="R.F.C" autoLayout={true} />
                <Column style={{textAlign:'center'}} field="nombre" header="Nombre o Razón Social" autoLayout={true} />
                <Column style={{textAlign:'center'}} field="correo" header="Correo" autoLayout={true} />
              </DataTable>

            </div>
          </div> */}
        </div>
      </div>
      {/* <Dialog header="Nuevo cliente" blockScroll visible={this.state.mostrarMoldaReceptor} modal={true} footer={dialogFooter} style={{ width: '60vw' }} onHide={() => this.setState({ receptor: {}, mostrarMoldaReceptor: false, erroresRequeridos: {} })}>
        <ScrollPanel style={{ width: '100%', height: '100px' }}>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-2">
              <label htmlFor="input">RFC:</label>
            </div>
            <div className="p-col-12 p-md-10">
              <InputText id="rfc" name="receptor.rfc" value={receptor.rfc || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.rfc ? 'p-error' : ''} onBlur={this.buscarRfcReceptor} />
              {erroresRequeridos.rfc ? <div> <Message severity="error" text={erroresRequeridos.rfc} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="textarea">Nombre:</label>
            </div>
            <div className="p-col-12 p-md-10">
              <InputText id="nombre" name="receptor.nombre" value={receptor.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.nombre ? 'p-error' : ''} />
              {erroresRequeridos.nombre ? <div> <Message severity="error" text={erroresRequeridos.nombre} /> </div> : null}
            </div>
         
          </div>
        </ScrollPanel>
      </Dialog> */}

      {/* <h3 style={{marginTop:'40px', marginBottom:'20px'}}><label>Uso del comprobante</label></h3>
      <div className="p-grid p-fluid" style={{marginBottom:'20px'}}>
        <div className="p-col-12">
          <Dropdown dataKey="id" placeholder="Selecciona Uso del comprobante" id="usoCfdi" name="receptor.usoCfdi" options={usosCfdi} value={receptor.usoCfdi} onChange={this.asignarValoresObjeto} itemTemplate={this.templateUsoCfdi} optionLabel="descripcion" className={erroresFrmDatos.usoCfdi ? 'p-error' : ''} />
          {erroresFrmDatos.usoCfdi ? <div><br /> <Message severity="error" text={erroresFrmDatos.usoCfdi} /> </div> : null}
        </div>
      </div>

      <h3 style={{marginTop:'40px', marginBottom:'20px'}}><label>Regimen Fiscal Receptor</label></h3>
      <div className="p-grid p-fluid" style={{marginBottom:'20px'}}>
        <div className="p-col-12">
          <Dropdown dataKey="id" placeholder="Selecciona Regimen Fiscal Receptor" id="regimenFiscalReceptor" name="receptor.regimenFiscalReceptor" options={listaRegimenFiscalReceptor} value={receptor.regimenFiscalReceptor} onChange={this.asignarValoresObjeto} itemTemplate={this.templateUsoCfdi} optionLabel="descripcion" className={erroresFrmDatos.usoCfdi ? 'p-error' : ''} />
          {erroresFrmDatos.regimenFiscalReceptor ? <div><br /> <Message severity="error" text={erroresFrmDatos.regimenFiscalReceptor} /> </div> : null}
        </div>
      </div> */}

      <div className="card card-w-title" >
        <div className="p-grid p-fluid" style={{ marginBottom: '20px' }}>
          <div className="p-col-12 p-md-4">
            <h4><strong>* Tipo de Comprobante:</strong></h4>
            <Dropdown id="tipoDeComprobante" name="tipoDeComprobante" value={this.state.tipoDeComprobante} options={facturas} onChange={this.asignarTipoComprobante} optionLabel="name" placeholder="Selecciona" autoWidth={false} className={erroresFrmDatos.tipoDeComprobante ? 'p-error' : ''} />
            {erroresFrmDatos.tipoDeComprobante ? <div> <Message severity="error" text={erroresFrmDatos.tipoDeComprobante} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4><strong>* Forma de pago:</strong></h4>
            <Dropdown id="formapago" disabled={banderaPagos} name="formaPago" value={this.state.formaPago} options={formasPagos} onChange={(e) => this.setState({ formaPago: e.target.value })} optionLabel="name" placeholder="Selecciona" autoWidth={false} className={erroresFrmDatos.formaPago ? 'p-error' : ''} />
            {erroresFrmDatos.formaPago ? <div> <Message severity="error" text={erroresFrmDatos.formaPago} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4><strong>* Metodo Pago:</strong></h4>
            <Dropdown id="metodoPago" disabled={banderaPagos} name="metodoPago" value={this.state.metodoPago} options={metodosPago} onChange={(e) => this.setState({ metodoPago: e.target.value })} optionLabel="name" placeholder="Selecciona" autoWidth={false} className={erroresFrmDatos.metodoPago ? 'p-error' : ''} />
            {erroresFrmDatos.metodoPago ? <div> <Message severity="error" text={erroresFrmDatos.metodoPago} /> </div> : null}
          </div>
        </div>
      </div>

      {!servicioAsignacionValoresObjetos.esObjetoVacio(receptor.rfc) && receptor.rfc === 'XAXX010101000' ? <InformacionGlobal informacionGlobal={informacionGlobal} erroresInformacion={erroresRequeridos} /> : ""}

      {banderaPagos ?
        <div className="card card-w-title" >
          <div className="p-grid p-fluid" style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0' }}>
            <div className="p-col-12  p-md-4">
              <Button label="Nuevo Pago" className="blue-grey-btn flat-btn" onClick={this.nuevo_pago} />
            </div>
          </div>
          <div className="p-col-12" style={{ marginTop: '20px' }}>
            <DataTable value={this.state.pagos.pago} header="PAGOS DEL COMPROBANTE" scrollable={true} scrollHeight="280px">
              <Column header="Editar" body={this.columnaEditarPagos} style={{ width: '80px', textAlign: 'center' }} />
              <Column body={this.columna_valor_fecha_pago} header="Fecha Pago" autoLayout={true} style={{ width: '80px', textAlign: 'center' }} />
              <Column field="formaDePagoP.name" header="Forma Pago" autoLayout={true} style={{ width: '80px', textAlign: 'center' }} />
              <Column field="monedaP.name" header="Moneda" autoLayout={true} style={{ width: '80px', textAlign: 'center' }} />
              <Column body={this.columna_valor_monto} header="Monto" autoLayout={true} style={{ width: '100px', textAlign: 'center' }} />
            </DataTable>
          </div>


        </div>
        :
        <div className="card card-w-title">
          <div className="p-grid p-fluid" style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0' }}>
            <div className="p-col-12  p-md-4">
              <Button label="Nuevo Concepto" className="blue-grey-btn flat-btn" onClick={this.nuevoConcepto} />
            </div>
          </div>
          <div className="p-col-12" style={{ marginTop: '20px' }}>
            <DataTable value={this.state.conceptos} header="CONCEPTOS O SERVICIOS DEL COMPROBANTE" scrollable={true} scrollHeight="280px">
              <Column header="Editar" body={this.columnaEditarConcepto} style={{ width: '100px', textAlign: 'center' }} />
              <Column field="cantidad" header="Cantidad" autoLayout={true} style={{ width: '80px', textAlign: 'center' }} />
              <Column field="unidad" header="Unidad" autoLayout={true} style={{ width: '80px', textAlign: 'center' }} />
              <Column field="descripcion" header="Descripción" autoLayout={true} style={{ width: '200px', textAlign: 'center' }} />
              <Column body={this.columna_valor_unitario} header="Valor Unitario" autoLayout={true} style={{ width: '100px', textAlign: 'center' }} />
              <Column body={this.columna_costo} header="Costo" autoLayout={true} style={{ width: '100px', textAlign: 'center' }} />
              <Column body={this.total_iva} header="Iva Trasladado" autoLayout={true} style={{ width: '100px', textAlign: 'center' }} />
              <Column body={this.total_retenido} header="Iva Retenido" autoLayout={true} style={{ width: '100px', textAlign: 'center' }} />
              <Column body={this.total_retenido_isr} header="Isr Retenido" autoLayout={true} style={{ width: '100px', textAlign: 'center' }} />
              <Column body={this.total} header="Total" autoLayout={true} style={{ width: '100px', textAlign: 'center' }} />
            </DataTable>

          </div>
        </div>}


      <Dialog header="Conceptos, los campos con * son requeridos." blockScroll visible={this.state.modalConceptos} modal={true} footer={dialogFooterConcepto} style={{ width: '60vw' }} onHide={() => this.setState({ concepto: { cantidad: 0.00, costo: 0.00, unidad: "PEAJE", atributos: {} }, modalConceptos: false, erroresRequeridos: {}, datoinformativo: {} })}>
        <ScrollPanel style={{ width: '100%', height: '300px' }}>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-2">
              <label htmlFor="cantidad">* Cantidad:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText id="cantidad" name="concepto.cantidad" value={concepto.cantidad || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.cantidad ? 'p-error' : ''} onBlur={this.realizar_calculos_cantidad_total} />
              {erroresRequeridos.cantidad ? <div> <Message severity="error" text={erroresRequeridos.cantidad} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="cantidad">* Concepto:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <Dropdown id="ingresodiverso" value={concepto.ingresodiverso || ''} options={listaMateriales} onChange={(e) => this.buscar_atributos(e)} optionLabel="descripcion" placeholder="Selecciona" autoWidth={false} />
              {erroresRequeridos.ingresodiverso ? <div> <Message severity="error" text={erroresRequeridos.ingresodiverso} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="costo">* Costo:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText id="costo" name="concepto.costo" value={concepto.costo || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.costo ? 'p-error' : ''} onBlur={this.realizar_calculos_cantidad_total} />
              {erroresRequeridos.costo ? <div> <Message severity="error" text={erroresRequeridos.costo} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="total">Total:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <div className="total" style={{ backgroundColor: '#00bcd4' }}>{servicioFormatos.formatearModena(concepto.total)}</div>
            </div>
          </div>
          {listaAtributos.map(
            (materialConcepto, index) =>
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                  <label htmlFor={materialConcepto.nombre}>{materialConcepto.nombre}:</label>
                </div>
                <div className="p-col-12 p-md-8">
                  <InputText id={index} name={materialConcepto.nombre} value={concepto.atributos[materialConcepto.nombre] || ''} placeholder={materialConcepto.nombre} onChange={this.asignarValorLista} />

                </div>
              </div>
          )
          }
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-2">
              <label htmlFor="textarea">Descripción detallada:</label>
            </div>
            <div className="p-col-10">
              <InputTextarea rows={3} cols={30} placeholder="Descripción" autoResize={true} name="concepto.descripcionDetallada" value={concepto.descripcionDetallada || ''} onChange={this.asignarValoresObjeto} />
            </div>
          </div>
        </ScrollPanel>
      </Dialog>



      <Dialog header="Impuesto traslados" visible={this.state.modalImpuestoTraslados} modal={true}
        footer={dialogModalImpuestoTraslados} onHide={this.cerrarModalImpuestosTraslados}>
        <TabView>
          <TabPanel header="Detalle de Impuestos">
            <div className="p-grid p-fluid">
              <div className="p-col-6">
                <label htmlFor="impuestoDR">* Impuesto</label>
                <Dropdown appendTo={document.body} dataKey="id" name="trasladoDR.impuestoDR" options={listaimpuestoTrasladado}
                  value={trasladoDR.impuestoDR || ""} onChange={this.asignarValoresObjeto}
                  itemTemplate={this.itemTemplateIdDescripcion} optionLabel="descripcion"
                  className={errores.impuestoDR ? 'p-error' : ''} />
                {errores.impuestoDR ? <div><Message severity="error" text={errores.impuestoDR} /></div> : null}
              </div>

              <div className="p-col-6">
                <label htmlFor="tipoFactorDR">* Tipo Factor</label>
                <Dropdown appendTo={document.body} dataKey="id" name="trasladoDR.tipoFactorDR" options={listaTipoFactor}
                  value={trasladoDR.tipoFactorDR || ""} onChange={this.asignarValoresObjeto}
                  itemTemplate={this.itemTemplateId} optionLabel="id"
                  className={errores.tipoFactorDR ? 'p-error' : ''} />
                {errores.tipoFactor ? <div><Message severity="error" text={errores.tipoFactorDR} /></div> : null}
              </div>
              {servicioObjetos.esObjetoVacio(listaTasaoCuota) ? "" :
              servicioObjetos.esObjetoVacio(objetoTasaOcuotaTraslado) ?
              
              <div className="p-col-6">
                <label htmlFor="tasaOCuotaDR">* Tasa o Cuota</label>
                <Dropdown appendTo={document.body} dataKey="id" name="trasladoDR.tasaOCuotaDR" options={listaTasaoCuota} s
                  value={trasladoDR.tasaOCuotaDR || ""} onChange={this.asignarValoresObjeto}
                  itemTemplate={this.itemTemplateDescripcion} optionLabel="id"
                  className={errores.tasaOCuota ? 'p-error' : ''} />
                {errores.tasaOCuotaDR ? <div><Message severity="error" text={errores.tasaOCuotaDR} /></div> : null}
              </div>:

<div className="p-col-6">
<label htmlFor="tasaOCuotaDR">* Tasa o Cuota</label>
<p>Valor minimo {objetoTasaOcuotaTraslado.valorMinimo}</p>
<p>Valor valorMaximo {objetoTasaOcuotaTraslado.valorMaximo}</p>
 <InputText type="number" id="minmax" name="trasladoDR.tasaOCuotaDR" value={trasladoDR.tasaOCuotaDR || ""} onChange={this.asignarValoresObjeto} min={objetoTasaOcuotaTraslado.valorMinimo} max={objetoTasaOcuotaTraslado.valorMaximo}  showButtons />
<Slider  name="trasladoDR.tasaOCuotaDR"  value={trasladoDR.tasaOCuotaDR || ""}  onChange={this.valorSlider}  min={objetoTasaOcuotaTraslado.valorMinimo} max={objetoTasaOcuotaTraslado.valorMaximo}   />
</div>

              

        }
             



            </div>

          </TabPanel>
        </TabView>

      </Dialog>

      <Dialog header="Impuesto Retenidos" visible={this.state.modalImpuestoRetenidos} modal={true} footer={dialogModalImpuestoRetenido} onHide={this.cerrarModalImpuestosRetenidos}>
        <TabView>
          <TabPanel header="Detalle de Impuestos">
            <div className="p-grid p-fluid">
            <div className="p-col-6">
                            <label htmlFor="impuesto">* Impuesto</label>
                            <Dropdown appendTo={document.body} dataKey="id" name="retencionDR.impuestoDR" options={listaimpuestoRetencion}
                                value={retencionDR.impuestoDR || ""} onChange={this.asignarValoresObjeto}
                                itemTemplate={this.itemTemplateDescripcion} optionLabel="descripcion"
                                className={errores.impuestoDR ? 'p-error' : ''} />
                            {errores.impuestoDR ? <div><Message severity="error" text={errores.impuestoDR} /></div> : null}
                        </div>
                        <div className="p-col-6">
                            <label htmlFor="tipoFactor">* Tipo Factor</label>
                            <Dropdown appendTo={document.body} dataKey="id" name="retencionDR.tipoFactorDR" options={listaTipoFactorRetenido}
                                value={retencionDR.tipoFactorDR || ""} onChange={this.asignarValoresObjeto}
                                itemTemplate={this.itemTemplateTipoFactor} optionLabel="id"
                                className={errores.tipoFactor ? 'p-error' : ''} />
                            {errores.tipoFactor ? <div><Message severity="error" text={errores.tipoFactor} /></div> : null}
                        </div>

                        {servicioObjetos.esObjetoVacio(listaTasaoCuotaRetenido) ? "" :

servicioObjetos.esObjetoVacio(objetoTasaoCuota) ?
                                <div className="p-col-6">
                                    <label htmlFor="tasaOCuotaDR">* Tasa o Cuota</label>
                                    <Dropdown appendTo={document.body} dataKey="id" name="retencionDR.tasaOCuotaDR" options={listaTasaoCuotaRetenido}
                                        value={retencionDR.tasaOCuotaDR || ""} onChange={this.asignarValoresObjeto}
                                        itemTemplate={this.itemTemplateDescripcion} optionLabel="id"
                                        className={errores.tasaOCuotaDR ? 'p-error' : ''} />
                                    {errores.tasaOCuotaDR ? <div><Message severity="error" text={errores.tasaOCuotaDR} /></div> : null}
                                </div>
                                :


                                <div className="p-col-6">
                <label htmlFor="tasaOCuotaDR">* Tasa o Cuota</label>
                <p>Valor minimo {objetoTasaoCuota.valorMinimo}</p>
                <p>Valor valorMaximo {objetoTasaoCuota.valorMaximo}</p>
                 <InputText type="number" id="minmax" name="retencionDR.tasaOCuotaDR" value={retencionDR.tasaOCuotaDR || ""} onChange={this.asignarValoresObjeto} min={objetoTasaoCuota.valorMinimo} max={objetoTasaoCuota.valorMaximo}  showButtons />
                <Slider  name="retencionDR.tasaOCuotaDR"  value={retencionDR.tasaOCuotaDR || ""}  onChange={this.valorSlider}  min={objetoTasaoCuota.valorMinimo} max={objetoTasaoCuota.valorMaximo}   />
              </div>
  
  }
            </div>
          </TabPanel>
        </TabView>
      </Dialog>




      <Dialog header="Pago, los campos con * son requeridos." visible={this.state.modalPagos} modal={true}
        footer={dialogFooterPago} onHide={this.cerrarModalPagos}>
        <TabView>
          <TabPanel header="Detalle del Pago">
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-2">
                <label htmlFor="fechaPago">* Fecha Pago:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <Calendar id="fechaPago" name="pago.fechaPago" className={erroresRequeridos.fechaPago ? 'p-error' : ''}
                  value={pago.fechaPago || ''} locale={servicioIdioma} onChange={this.asignarValoresObjeto} showIcon={true}
                  dateFormat="yy-mm-dd" showTime={true} />
                {erroresRequeridos.fechaPago ? <div> <Message severity="error" text={erroresRequeridos.fechaPago} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="formaDePagoP">* Forma Pago:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <Dropdown id="formapago" name="pago.formaDePagoP" value={pago.formaDePagoP || ''} options={formasPagos} onChange={this.asignarValoresObjeto} optionLabel="name"
                  placeholder="Selecciona Forma Pago" autoWidth={false} className={erroresRequeridos.formaDePagoP ? 'p-error' : ''} />
                {erroresRequeridos.formaDePagoP ? <div> <Message severity="error" text={erroresRequeridos.formaDePagoP} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="monedaP"> Moneda P:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <Dropdown id="monedaP" name="pago.monedaP" placeholder="Moneda DR" value={pago.monedaP || ''} options={monedasDR} onChange={this.asignarValoresObjeto} optionLabel="name"
                  placeholder="Selecciona Moneda P" autoWidth={false} />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="tipoCambioP"> Tipo Cambio:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="pago.tipoCambioP" value={pago.tipoCambioP || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Tipo Cambio" autoWidth={false} />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="monto">* Monto:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="pago.monto" value={pago.monto || ''} onChange={this.asignarValoresObjeto}
                  className={erroresRequeridos.monto ? 'p-error' : ''} />
                {erroresRequeridos.monto ? <div> <Message severity="error" text={erroresRequeridos.monto} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="numOperacion"> Num Operación:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="pago.numOperacion" value={pago.numOperacion || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Num Operación" />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="rfcEmisorCtaOrd"> Rfc Emisor Cta Ord:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="pago.rfcEmisorCtaOrd" value={pago.rfcEmisorCtaOrd || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Rfc Emisor Cta Ord" />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="nomBancoOrdExt"> Banco Ord Ext:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="pago.nomBancoOrdExt" value={pago.nomBancoOrdExt || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Banco Ord Ext" />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="ctaOrdenante"> Cta Ordenante:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="pago.ctaOrdenante" value={pago.ctaOrdenante || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Cta Ordenante" />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="rfcEmisorCtaBen"> Rfc Emisor Cta Ben:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="pago.rfcEmisorCtaBen" value={pago.rfcEmisorCtaBen || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Rfc Emisor Cta Ben" />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="ctaBeneficiario"> Cta Beneficiario:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="pago.ctaBeneficiario" value={pago.ctaBeneficiario || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Cta Beneficiario" />
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Documento Relacionado">
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-2">
                <label htmlFor="fechaPago">* UUID:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="doctoRelacionado.idDocumento" value={doctoRelacionado.idDocumento || ''} onChange={this.asignarValoresObjeto}
                  placeholder="UUID" />
                {erroresRequeridos.idDocumento ? <div> <Message severity="error" text={erroresRequeridos.idDocumento} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="serie">Serie:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="doctoRelacionado.serie" value={doctoRelacionado.serie || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Serie" />

              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="folio">Folio:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="doctoRelacionado.folio" value={doctoRelacionado.folio || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Folio" />

              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="monedaDR">* Moneda DR:</label>
              </div>
              <div className="p-col-12 p-md-4">

                <Dropdown id="monedaDR" name="doctoRelacionado.monedaDR" placeholder="Moneda DR" value={doctoRelacionado.monedaDR || ''} options={monedasDR} onChange={this.asignarValoresObjeto} optionLabel="name"
                  placeholder="Selecciona" autoWidth={false} className={erroresRequeridos.monedaDR ? 'p-error' : ''} />
                {erroresRequeridos.monedaDR ? <div> <Message severity="error" text={erroresRequeridos.monedaDR} /> </div> : null}
              </div>


              {/* <div className="p-col-12 p-md-2">
                <label htmlFor="tipoCambioDR">Tipo Cambio DR:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="doctoRelacionado.tipoCambioDR" value={doctoRelacionado.tipoCambioDR || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Tipo Cambio DR" />
              </div> */}
              {/* <div className="p-col-12 p-md-2">
                <label htmlFor="metodoDePagoDR">* Metodo de Pago DR:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <Dropdown id="metodoDePagoDR" name="doctoRelacionado.metodoDePagoDR" value={doctoRelacionado.metodoDePagoDR || ''} options={metodosPago} onChange={this.asignarValoresObjeto} optionLabel="name"
                  placeholder="Selecciona" autoWidth={false} className={erroresRequeridos.metodoDePagoDR ? 'p-error' : ''} />
                {erroresRequeridos.metodoDePagoDR ? <div> <Message severity="error" text={erroresRequeridos.metodoDePagoDR} /> </div> : null}
              </div> */}
              <div className="p-col-12 p-md-2">
                <label htmlFor="numParcialidad">Num Parcialidad:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="doctoRelacionado.numParcialidad" value={doctoRelacionado.numParcialidad || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Num Parcialidad" />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="ImpSaldoAnt">Imp Saldo Ant:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="doctoRelacionado.impSaldoAnt" value={doctoRelacionado.impSaldoAnt || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Imp Saldo Ant" />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="ImpPagado">Imp Pagado:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="doctoRelacionado.impPagado" value={doctoRelacionado.impPagado || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Imp Pagado" />
              </div>
              <div className="p-col-12 p-md-2">
                <label htmlFor="ImpSaldoInsoluto">Imp Saldo Insoluto:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText name="doctoRelacionado.impSaldoInsoluto" value={doctoRelacionado.impSaldoInsoluto || ''} onChange={this.asignarValoresObjeto}
                  placeholder="Imp Saldo Insoluto" />
              </div>

              <div className="p-col-12 p-md-2">
                <label htmlFor="Objeto Impuesto">Objeto Impuesto:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <Dropdown id="doctoRelacionado.objetoImpDR" name="doctoRelacionado.objetoImpDR" placeholder="Objeto Impuesto" value={doctoRelacionado.objetoImpDR || ''} options={objetosIMpuesto} onChange={this.asignarValoresObjeto} optionLabel="name"
                  placeholder="Selecciona Objeto" autoWidth={false} />
                  {erroresRequeridos.objetoImpuesto ? <div> <Message severity="error" text={erroresRequeridos.objetoImpuesto} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-6">
              </div>
              <div className="p-col-12 p-md-4">
              </div>


              {objetoImpuesto === "02" || objetoImpuesto === "03" ?
                <div className="p-col-12 p-md-2">
                  <Button label="Nuevo Impuesto Traslado" onClick={this.abrirModalImpuestoTraslado} />
                </div>
                 
                : ""}
                 {erroresRequeridos.impuestos ? <div> <Message severity="error" text={erroresRequeridos.impuestos} /> </div> : null}


              {objetoImpuesto === "02" || objetoImpuesto === "03" ?
                <div className="p-col-12 p-md-2">
                  <Button label="Nuevo Impuesto Retención" onClick={this.abrirModalImpuestoRetenido} />
                </div>
                : ""}
                 {erroresRequeridos.impuestos ? <div> <Message severity="error" text={erroresRequeridos.impuestos} /> </div> : null}
              {!servicioObjetos.esObjetoVacio(listaImpuestosTrasladados) ? 
                <div className="p-col-12 p-md-12">
                  <div className="card">
                    <DataTable value={listaImpuestosTrasladados} responsive={true}>
                      <Column header="Impuesto" body={this.templateImpuesto}></Column>
                      <Column field="tipoFactor" header="Tipo Factor" body={this.templateTipoFactor}></Column>
                      <Column header=" Tasa o Cuota" body={this.templateTasaOCuota}></Column>
                      <Column body={this.templateOpcionesTraslados} />
                    </DataTable>
                  </div>

                </div>
                : ""}
{!servicioObjetos.esObjetoVacio(listaImpuestosRetenciones) ? 
<div className="p-col-12 p-md-12">
                  <div className="card">
                    <DataTable value={listaImpuestosRetenciones} responsive={true}>
                      <Column header="Impuesto" body={this.templateImpuesto}></Column>
                      <Column field="tipoFactor" header="Tipo Factor" body={this.templateTipoFactor}></Column>
                      <Column header=" Tasa o Cuota" body={this.templateTasaOCuota}></Column>
                      <Column body={this.templateOpcionesRetenidos} />
                    </DataTable>
                  </div>

                </div>
:""}

              {/* <div className="p-col-12 p-md-2">
                <label htmlFor="ObjetoImpDR">* Objeto Imp DR:</label>
              </div>
              <div className="p-col-12 p-md-4">
                <Dropdown name="doctoRelacionado.objetoImpDR" value={doctoRelacionado.objetoImpDR || ''} onChange={this.asignarValoresObjeto} options={objetoImpDR}
                  placeholder="Objeto Imp DR"  autoWidth={false} optionLabel="name"/>
                    {erroresRequeridos.objetoImpDR ? <div> <Message severity="error" text={erroresRequeridos.objetoImpDR} /> </div> : null}
              </div> */}
              {/** <div className="p-col-12">
                <DataTable value={this.state.listaDoctoRelacionado} header="Documentos Relacionados del Pago" responsive={true}>
                  <Column field="cantidad" header="Serie" autoLayout={true} />
                  <Column field="unidad" header="Folio" autoLayout={true} />
                  <Column field="descripcion" header="UUID" autoLayout={true} />
                  <Column body={this.columna_valor_unitario} header="Imp Saldo Ant" autoLayout={true} style={{ width: '100px' }} />
                  <Column body={this.columna_costo} header="Imp Pagado" autoLayout={true} style={{ width: '100px' }} />
                  <Column body={this.total_iva} header="Imp Saldo Insoluto" autoLayout={true} style={{ width: '100px' }} />
                </DataTable>
              </div> */}
            </div>
          </TabPanel>
        </TabView>

      </Dialog>

      <h3 style={{ marginTop: '40px', marginBottom: '20px' }}><label>Importe sobre el comprobante</label></h3>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4" style={{ textAlign: 'center' }}>
          <h4>Subtotal</h4>
          <p>{servicioFormatos.formatearModena(comprobante.subTotal)}</p>
        </div>
        <div className="p-col-12 p-md-4" style={{ textAlign: 'center' }}>
          <h4>IVA</h4>
          <p>{servicioFormatos.formatearModena(comprobante.impuestos.totalImpuestosTrasladados)}</p>
        </div>
        <div className="p-col-12 p-md-4" style={{ textAlign: 'center' }}>
          <h4>Total</h4>
          <p>{servicioFormatos.formatearModena(comprobante.total)}</p>
        </div>
      </div>
      {apartadoCfdiRelacionado ? <div className="card card-w-title">
        <div className="p-grid p-fluid" style={{ marginTop: '10px', marginLeft: '20px' }}>
          <div className="p-col-12 p-md-2">
            <label htmlFor="cfdiRelacionado"> Cfdi Relacionado</label>
          </div>
          <div className="p-col-12 p-md-10">
            <Checkbox inputId="cb1" value="Cfdi Relacionado" checked={mostrarCfdiRelacionado} onChange={this.crearCfdiRelacionado}></Checkbox>
          </div>
        </div>
      </div> : ''}

      {mostrarCfdiRelacionado ?
        <div className="card card-w-title">
          <div className="p-grid p-fluid" style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div className="p-col-12 p-md-6">
              <h4>Tipo relación:</h4>
              <Dropdown id="tiporelacion" value={this.state.tiporelacion} options={tiposRelacion} onChange={(e) => this.setState({ tiporelacion: e.target.value })} optionLabel="name" placeholder="Selecciona tipo relación" autoWidth={false} />
            </div>
            <div className="p-col-12 p-md-4">
              <h4>Busca folio fiscal:</h4>
              <InputText id="folioFiscal" name="folioFiscal.uuid" value={folioFiscal.uuid || ''} onChange={this.asignarValoresObjeto} />
            </div>
          </div>
        </div>
        : ''}
      <center>
        <div className="p-grid p-fluid" style={{ marginTop: '40px', width: '60%', marginBottom: '60px' }}>
          <div className="p-col-12">
            <Button label="Generar Comprobante" className="indigo-btn flat-btn" onClick={this.prefactura} style={{ width: '50%' }} />
          </div>
        </div>
      </center>


      <Dialog header="Confirmación Facturación" visible={this.state.confirmacionFacturacion} modal={true} style={{ width: '80vw' }} footer={dialogFooterConfirmacionFacturacion} onHide={this.cerrar_modal_confirmacion_facturacion}>
        <ScrollPanel style={{ width: '100%', height: '300px' }}>
          <DataTable value={listaReceptorConfirmacion} paginatorPosition="both" selectionMode="single" header="Datos del Receptor" responsive={true}>
            <Column field="rfc" header="R.F.C" sortable={true} />
            <Column field="nombre" header="Nombre o Razón Social" sortable={true} />
            <Column body={this.columna_uso_cfdi} header="UsoCfdi" sortable={true} />
          </DataTable>

          {banderaPagos ? "" :
            <DataTable value={this.state.conceptos} header="Conceptos o Servicios del Comprobante" responsive={true}>
              <Column field="cantidad" header="Cantidad" autoLayout={true} />
              <Column field="unidad" header="Unidad" autoLayout={true} />
              <Column field="descripcion" header="Descripción" autoLayout={true} />
              <Column body={this.columna_valor_unitario} header="Valor Unitario" autoLayout={true} style={{ width: '100px' }} />
              <Column body={this.columna_costo} header="Costo" autoLayout={true} style={{ width: '100px' }} />
              <Column body={this.total_iva} header="Iva Trasladado" autoLayout={true} style={{ width: '100px' }} />
              <Column body={this.total_retenido} header="Iva Retenido" autoLayout={true} style={{ width: '100px' }} />
              <Column body={this.total_retenido_isr} header="Isr Retenido" autoLayout={true} style={{ width: '100px' }} />
              <Column body={this.total} header="Total" autoLayout={true} style={{ width: '100px' }} />
            </DataTable>}
        </ScrollPanel>
      </Dialog>

      <Dialog header="Resultado facturación" visible={mostrarModalResultado} style={{ width: '80vw' }} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={this.cerrarModalResultados}>
        <ScrollPanel style={{ width: '100%', height: '300px' }}>
          <DataTable value={listaResultados} header="Facturas generadas" responsive={true}>
            <Column body={this.templateErrorResultado} header="Estado" />
            <Column field="mensaje" header="Observación" />
            <Column field="objeto.uuid" header="UUID" />
            <Column field="objeto.serie" header="Serie" />
            <Column field="objeto.folio" header="Folio" />
            <Column body={this.templateDescargaArchivos} style={{ textAlign: 'center', width: '8em' }} header="Descargar archivos" />
          </DataTable>
        </ScrollPanel>
      </Dialog>

    </div>);
  }
}